const classesLink = { routeKey: "classes", to: "/classes" };
const classCrumb = { type: "class" };
const settingsLink = { routeKey: "settings", to: "/settings" };

function page(path, routeKey) {
  return { path, crumbs: [{ routeKey }] };
}

function settingsScreen(path, routeKey) {
  return { path, crumbs: [settingsLink, { routeKey }] };
}

function classScreen(path, leaf, options = {}) {
  const crumbs = [classesLink, classCrumb];
  if (options.parent) crumbs.push(options.parent);
  if (leaf) crumbs.push(leaf);
  return {
    path,
    crumbs,
    classSwitchPath: options.switchPath || path
  };
}

function studentScreen(path, routeKey, options = {}) {
  const crumbs = [
    { routeKey: "studentProfile", to: "/student/:studentId" },
    { type: "studentName", to: "/student/:studentId" }
  ];
  if (options.parent) crumbs.push(options.parent);
  crumbs.push({ routeKey });
  return { path, crumbs };
}

const smartMinutes = {
  routeKey: "classSmartMinutes",
  to: "/classes/:id/ata-inteligente"
};

const studentSmartMinutes = {
  routeKey: "studentSmartMinutes",
  to: "/student/:studentId/ata-inteligente"
};

const individualOccurrences = {
  labelKey: "individualOccurrences.title",
  to: "/classes/:id/individualOccurrences"
};

const dailySummary = {
  routeKey: "dailySummary",
  to: "/classes/:id/dailySummary"
};

const classStages = {
  routeKey: "classStages",
  to: "/classes/:id/stages"
};

export default [
  page("/", "home"),
  page("/login", "login"),
  settingsScreen("/account/change-password", "changePassword"),
  page("/communication/:id", "communications"),
  page("/communication", "communications"),
  page("/notifications", "notifications"),
  page("/classes", "classes"),
  page("/solicitacoes", "jobRequests"),
  classScreen("/classes/:id"),
  classScreen("/classes/:id/overview", { labelKey: "classes.overview.title" }),
  classScreen("/classes/:id/reports", { routeKey: "classReports" }),
  classScreen("/classes/:id/occurrences", { routeKey: "classOccurrences" }),
  classScreen("/classes/:id/occurrencesAdvanced", {
    routeKey: "classOccurrenceAdvanced"
  }),
  classScreen("/classes/:id/refo", { routeKey: "classRefo" }),
  classScreen("/classes/:id/stages", { routeKey: "classStages" }),
  classScreen(
    "/classes/:id/stages/new",
    { routeKey: "classStageNew" },
    { parent: classStages, switchPath: "/classes/:id/stages" }
  ),
  classScreen(
    "/classes/:id/stages/:stageId",
    { routeKey: "classStageForm" },
    { parent: classStages, switchPath: "/classes/:id/stages" }
  ),
  classScreen("/classes/:id/grades", { routeKey: "classGradesV1" }),
  classScreen("/classes/:id/gradesV2", { routeKey: "classGradesV2" }),
  classScreen("/classes/:id/frequency", { routeKey: "classFrequency" }),
  page("/classes/individualOccurrences", "individualOccurrencesClass"),
  classScreen("/classes/:id/individualOccurrences", {
    labelKey: "individualOccurrences.title"
  }),
  classScreen(
    "/classes/:id/individualOccurrences/:studentId",
    { routeKey: "individualOccurrences" },
    {
      parent: individualOccurrences,
      switchPath: "/classes/:id/individualOccurrences"
    }
  ),
  classScreen("/classes/:id/individualReport", {
    routeKey: "individualReport"
  }),
  classScreen(
    "/classes/:id/individualReport/new",
    { routeKey: "individualReportNew" },
    { switchPath: "/classes/:id/individualReport/new" }
  ),
  classScreen(
    "/classes/:id/individualReport/edit",
    { routeKey: "individualReportEdit" },
    { switchPath: "/classes/:id/individualReport/new" }
  ),
  classScreen("/classes/:id/dailySummary", { routeKey: "dailySummary" }),
  classScreen(
    "/classes/:id/dailySummary/new",
    { routeKey: "dailySummaryNew" },
    { parent: dailySummary, switchPath: "/classes/:id/dailySummary" }
  ),
  classScreen(
    "/classes/:id/dailySummary/edit",
    { routeKey: "dailySummaryEdit" },
    { parent: dailySummary, switchPath: "/classes/:id/dailySummary" }
  ),
  classScreen("/classes/:id/schedule", { routeKey: "classSchedule" }),
  classScreen("/classes/:id/plan", { routeKey: "classPlan" }),
  page("/schedule", "schedule"),
  page("/teachers", "teachers"),
  {
    path: "/teachers/:id",
    crumbs: [
      { routeKey: "teachers", to: "/teachers" },
      { routeKey: "teacherDetails" }
    ]
  },
  page("/support", "support"),
  page("/demo-settings", "demoSettings"),
  page("/settings", "settings"),
  settingsScreen("/settings/access-control", "accessControl"),
  settingsScreen("/settings/class-access", "classAccess"),
  settingsScreen("/settings/lb-sync", "lbSync"),
  settingsScreen("/settings/general-board", "generalBoard"),
  page("/students", "students"),
  page("/student/:studentId", "studentProfile"),
  studentScreen("/student/:studentId/info", "studentInfo"),
  studentScreen("/student/:studentId/notes", "studentNotes"),
  studentScreen("/student/:studentId/statistics", "studentStatistics"),
  studentScreen("/student/:studentId/charts", "studentCharts"),
  studentScreen("/student/:studentId/schedule", "studentSchedule"),
  studentScreen("/student/:studentId/occurrences", "studentOccurrences"),
  studentScreen("/student/:studentId/custom/:menuKey", "studentCustomMenu"),
  studentScreen("/student/:studentId/reports", "studentReports"),
  classScreen("/classes/:id/ata-inteligente", {
    routeKey: "classSmartMinutes"
  }),
  classScreen(
    "/classes/:id/ata-inteligente/new",
    { routeKey: "classSmartMinutesNew" },
    { parent: smartMinutes, switchPath: "/classes/:id/ata-inteligente" }
  ),
  classScreen(
    "/classes/:id/ata-inteligente/:ataId",
    { routeKey: "classSmartMinutesDetail" },
    { parent: smartMinutes, switchPath: "/classes/:id/ata-inteligente" }
  ),
  studentScreen("/student/:studentId/ata-inteligente", "studentSmartMinutes"),
  studentScreen(
    "/student/:studentId/ata-inteligente/new",
    "studentSmartMinutesNew",
    { parent: studentSmartMinutes }
  ),
  studentScreen(
    "/student/:studentId/ata-inteligente/:ataId",
    "studentSmartMinutesDetail",
    { parent: studentSmartMinutes }
  )
];
